{
  "Yapılacaklar": "Yapılacaklar",
  "yapilacaklar": {
    "Oluşturma Tarih": "Oluşturma Tarihi",
    "Yapılacaklar": "Yapılacaklar",
    "yapilacaklar": "yapilacaklar",
    "talep_takip": "talep_takip",
    "Talep Edilen": "Talep Edilen",
    "Talep Durumu": "Talep Durumu",
    "Talep Notu": "Talep Notu",
    "Sonuç Tarih": "Sonuç Tarih",
    "Sonuç": "Sonuç",
    "Ara": "Ara",
    "Temizle": "Temizle",
    "Kapat": "Kapat",
    "Durum": "Durum",
    "Konu": "Konu",
    "Yenile": "Yenile",
    "Yeni": "Yeni",
    "Güncelle": "Güncelle",
    "Kaydet": "Kaydet",
    "Aktif": "Aktif",
    "Pasif": "Pasif",
    "Not": "Not"
  }
}
